import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Schedule } from '@mui/icons-material';
import { Box, Button, Typography } from '@mui/material';

import './Error.scss';

export default function ErrorPage() {
    const { t } = useTranslation();
    const [cooldown, setCooldown] = useState(30);

    useEffect(() => {
        if (cooldown <= 0) return;
        const timer = setTimeout(() => setCooldown(cooldown - 1), 1000);
        return () => clearTimeout(timer);
    }, [cooldown]);

    return (
        <Box className="error wrapper">
            <Box className="headline">
                <Schedule className="iconHead cancelIco" />
                <Typography component="h3">
                    {t('common.resultStatus.tradeError.title')}
                </Typography>
            </Box>
            <Typography className="message">
                {t('common.resultStatus.tradeError.message')}
            </Typography>
            <Button
                variant="contained"
                className="refreshBtn"
                disabled={cooldown > 0}
                onClick={() => window.location.reload()}
            >
                {t('common.resultStatus.tradeError.refresh')}
                {cooldown > 0 && ` (${cooldown}s)`}
            </Button>
        </Box>
    );
}
